import { render, staticRenderFns } from "./AccountAdminBranchUsage.vue?vue&type=template&id=3a1593cc&"
import script from "./AccountAdminBranchUsage.vue?vue&type=script&lang=js&"
export * from "./AccountAdminBranchUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports